<div class="delivery-dialog">

    <div class="section-heading">
        <h5 *ngIf="!showDeliveryDetails">Select your Delivery Location</h5>
        <h5 *ngIf="showDeliveryDetails">Delivery Location</h5>
        <button class="close-dialog-btn" (click)="closeDialog()" aria-label="Close dialog">
            <svg class="close-icon-svg" viewBox="0 0 24 24" width="20" height="20">
                <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
        </button>
    </div>

    <div mat-dialog-content class="dialog-content">
        <!-- Search Section -->
        <div class="search-section" *ngIf="!showDeliveryDetails">
            <div class="search-container">
                <input type="text" class="search-input" placeholder="Search for your area, landmark, or pincode"
                    autocorrect="off" autocapitalize="off" spellcheck="false" #search [disabled]="!newDeliveryDetails"
                    (input)="onSearchInput(search.value)" (keydown.enter)="$event.preventDefault()" />

                <button *ngIf="searchInput" class="clear-btn" (click)="clearSearch()" aria-label="Clear">
                    <lucide-icon name="x"></lucide-icon>
                </button>

                <button class="gps-btn" (click)="fetchCurrentLoc()" aria-label="Current location"
                    matTooltip="Use my current location">
                    <lucide-icon name="locate"></lucide-icon>
                </button>
            </div>
        </div>

        <!-- Map Section -->
        <!-- <div class="map-section" *ngIf="!showDeliveryDetails">
            <div class="map-wrapper">

                <google-map height="400px" width="100%" [center]="center" [zoom]="zoom">
                    <map-marker [position]="markerPosition" [options]="markerOptions"
                        (mapDragend)="markerDragEnd($event)">
                    </map-marker>
                </google-map>

                <div class="map-overlay" *ngIf="!newDeliveryDetails">
                    <mat-icon class="lock-icon">lock</mat-icon>
                    <span>Enable delivery to interact with map</span>
                </div>
            </div>
        </div> -->

        <!-- Toast Message -->
        <div *ngIf="showToast" class="toast-message">
            <mat-icon class="warning-icon">warning</mat-icon>
            <span>Delivery to pincode <strong>{{ pincode }}</strong> is currently not available</span>
        </div>

        <!-- Delivery Details Section - Show after selection -->
        <!-- <div *ngIf="showDeliveryDetails && selectedLocation" class="delivery-details-section">
            <div class="delivery-details-card">
                <div class="delivery-header">
                    <div class="header-left">
                        <lucide-icon name="map-pin" class="delivery-icon"></lucide-icon>
                        <h3>Selected Location</h3>
                    </div>
                    <button class="edit-btn" (click)="onEditLocation()">
                        <lucide-icon name="edit-2"></lucide-icon>
                        Edit
                    </button>
                </div>

                <div class="delivery-info">
                    <div class="info-row">
                        <span class="label">Location Name:</span>
                        <span class="value">{{ selectedLocation.locationName }}</span>
                    </div>
                    <div class="info-row" *ngIf="selectedLocation.address1">
                        <span class="label">Address Line 1:</span>
                        <span class="value">{{ selectedLocation.address1 }}</span>
                    </div>
                    <div class="info-row" *ngIf="selectedLocation.address2">
                        <span class="label">Address Line 2:</span>
                        <span class="value">{{ selectedLocation.address2 }}</span>
                    </div>
                    <div class="info-row" *ngIf="selectedLocation.pincode">
                        <span class="label">PIN Code:</span>
                        <span class="value">{{ selectedLocation.pincode }}</span>
                    </div>
                    <div class="info-row" *ngIf="selectedLocation.distance">
                        <span class="label">Distance:</span>
                        <span class="value">
                            <lucide-icon name="footprints" class="distance-icon"></lucide-icon>
                            {{ selectedLocation.distance }} km away
                        </span>
                    </div>
                </div>

                <div class="delivery-notes" *ngIf="selectedLocation.notes">
                    <span class="label">Notes:</span>
                    <p>{{ selectedLocation.notes }}</p>
                </div>
            </div>
        </div> -->

        <div *ngIf="showDeliveryDetails && selectedLocation" class="delivery-details-compact">
            <div class="compact-content">

                <div class="location-info">
                    <lucide-icon name="map-pin" class="pin-icon"></lucide-icon>

                    <div class="location-text">
                        <div class="name" style="color: green;">
                            Delivered From
                        </div>
                        <div class="name">
                            {{ selectedLocation.locationName }}
                        </div>

                        <div class="address">
                            {{ selectedLocation.address1 }}
                        </div>

                        <div class="pincode" *ngIf="selectedLocation.pincode">
                            PIN: {{ selectedLocation.pincode }}
                        </div>
                    </div>
                </div>

                <button class="edit-btn-small" (click)="onEditLocation()">
                    <lucide-icon name="pencil"></lucide-icon>
                </button>

            </div>
        </div>

        <!-- Preferred Locations -->
        <div *ngIf="!showDeliveryDetails && !showClickButton" class="locations-section">
            <div class="section-header">
                <h3>📍 Preferred Locations</h3>
                <span class="location-count">{{ locationSetupList.length }} saved</span>
            </div>

            <div class="locations-grid">
                <div *ngFor="let locationSetup of locationSetupList; let i = index" class="location-card"
                    [class.selected]="i === selectedIndex" (click)="onSelectLocation(i)">

                    <div class="location-content">
                        <div class="location-icon">
                            <lucide-icon name="map-pin"></lucide-icon>
                        </div>
                        <div class="location-details">
                            <div class="location-name">{{ locationSetup.locationName }}</div>
                            <div *ngIf="locationSetup.address1" class="address">{{ locationSetup.address1 }}</div>
                            <div *ngIf="locationSetup.address2" class="address">{{ locationSetup.address2 }}</div>
                            <div *ngIf="locationSetup.pincode" class="pincode">PIN: {{ locationSetup.pincode }}</div>
                            <div *ngIf="locationSetup.distance" class="distance">
                                <lucide-icon name="footprints" class="distance-icon"></lucide-icon>
                                {{ locationSetup.distance }} km away
                            </div>
                        </div>
                        <div class="selection-indicator" *ngIf="i === selectedIndex">
                            <lucide-icon name="circle-check" class="check-icon"></lucide-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="showDeliveryDetails"
        class="max-w-7xl mx-auto p-1 bg-gradient-to-br from-gray-50 to-white min-h-screen font-sans">

        <!-- Main Content Grid -->
        <div class="gap-2" style="display: flex; flex-direction: column;">

            <!-- Left Column - Saved Addresses (Horizontal Scroll) -->
            <div class="lg:col-span-1">
                <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-2">
                    <div class="flex items-center justify-between mb-1 border-b border-gray-100">
                        <h3 class="text-xs font-bold text-gray-900 flex items-center gap-2 whitespace-nowrap">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path
                                    d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                            </svg>
                            Saved Addresses
                        </h3>
                        <span
                            class="text-xs font-semibold bg-orange-100 text-orange-600 px-2 py-1 rounded-full whitespace-nowrap">
                            {{deliveryListWithAddOption?.length - 1 || 0}} saved
                        </span>
                        <h3 class="text-xs font-bold text-gray-900 flex items-center whitespace-nowrap add-address-content"
                            (click)="onDeliveryDetailsClick({ isNew: true }, deliveryDetailsList.length)">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 text-orange-400 group-hover:text-orange-500" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" color="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            New Address
                        </h3>

                    </div>

                    <!-- HORIZONTAL SCROLL CONTAINER - FIXED -->
                    <!-- <div class="horizontal-scroll-wrapper"
                        style="overflow-x: auto; overflow-y: hidden; padding-bottom: 10px; width: 100%;"> -->
                    <div class="address-scroll">
                        <div class="address-list">
                            <!-- Flex container with enough width to trigger scroll -->
                            <!-- <div class="d-flex"
                            style="display: flex; gap: 12px; width: max-content; min-width: 100%; padding: 4px 2px;"> -->

                            <!-- Add New Address Card -->
                            <div *ngFor="let deliveryDetail of deliveryDetailsList; let i = index"
                                (click)="onDeliveryDetailsClick(deliveryDetail, i)" class="address-card"
                                style="flex: 0 0 auto; width: 150px; cursor: pointer; transition: all 0.2s;">


                                <div>
                                    <div class="relative bg-white rounded-xl p-1 border-2 transition-all hover:shadow-md"
                                        [ngClass]="i == toogle ? 'border-orange-500 bg-orange-50/50 shadow-sm' : 'border-gray-200 hover:border-orange-300'">

                                        <div *ngIf="i == toogle"
                                            class="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center shadow-sm">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white"
                                                viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd"
                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </div>

                                        <div class="space-y-2"
                                            style="height: 100%; display: flex; flex-direction: column;">
                                            <div class="flex items-start justify-between">
                                                <div class="flex items-center gap-2" style="flex: 1; min-width: 0;">
                                                    <div
                                                        class="w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
                                                        <span class="text-xs font-bold text-orange-600">{{
                                                            deliveryDetail?.contactName?.charAt(0) }}</span>
                                                    </div>
                                                    <div style="min-width: 0; flex: 1;">
                                                        <h4 class="text-sm font-semibold text-gray-900 truncate">{{
                                                            deliveryDetail?.contactName }}</h4>
                                                        <p class="text-xs text-orange-600 truncate">{{
                                                            deliveryDetail?.contactNo }}</p>
                                                    </div>
                                                </div>
                                                <button type="button"
                                                    class="text-gray-400 hover:text-red-500 p-1 rounded hover:bg-red-50 flex-shrink-0"
                                                    (click)="onDeleteDeliveryDetails(deliveryDetail, i); $event.stopPropagation()">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                        viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                </button>
                                            </div>

                                            <div class="text-xs text-gray-600 space-y-1" style="flex: 1;">
                                                <p class="truncate">{{ deliveryDetail?.shippingPlotNo }}, {{
                                                    deliveryDetail?.shippingAddress }}</p>
                                                <p class="truncate">{{ deliveryDetail?.shippingCity?.cityName }}, {{
                                                    deliveryDetail?.shippingPinCode }}</p>
                                            </div>

                                            <!-- <button
                                                class="w-full mt-2 py-2 text-xs font-medium rounded-lg transition-all flex-shrink-0"
                                                [ngClass]="i == toogle ? 'bg-orange-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'">
                                                {{ i == toogle ? 'Selected' : 'Select Address' }}
                                            </button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column - Form (Vertical Scroll) -->
            <div class="lg:col-span-2">
                <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">

                    <!-- VERTICAL SCROLL CONTAINER -->
                    <div class="overflow-y-auto scrolling-div">
                        <form [formGroup]="createSetUpFormDelivery" (ngSubmit)="onCreateSetUpClick()"
                            class="p-1 space-y-6">
                            <!-- Contact Information -->
                            <div>
                                <h4 class="text-xs font-semibold text-gray-900 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Contact Information
                                </h4>

                                <div class="grid grid-cols-2 md:grid-cols-2 gap-1">
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Full Name</label>
                                        <input type="text" formControlName="customerName" placeholder="Enter full name"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                                    </div>
                                    <!-- <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Mobile Number</label>
                                        <input type="tel" formControlName="contactNo" placeholder="Enter mobile number"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                                    </div> -->
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">
                                            Mobile Number <span class="text-red-500">*</span>
                                        </label>

                                        <input type="tel" formControlName="contactNo" maxlength="10"
                                            placeholder="Enter mobile number" (input)="onlyNumbers($event)"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all"
                                            [ngClass]="{
            'border-red-500':
            createSetUpFormDelivery.get('contactNo')?.invalid &&
            createSetUpFormDelivery.get('contactNo')?.touched,
            'border-gray-300':
            !(createSetUpFormDelivery.get('contactNo')?.invalid &&
            createSetUpFormDelivery.get('contactNo')?.touched)
        }" />

                                        <div *ngIf="createSetUpFormDelivery.get('contactNo')?.touched &&
                createSetUpFormDelivery.get('contactNo')?.invalid">

                                            <small class="text-red-500"
                                                *ngIf="createSetUpFormDelivery.get('contactNo')?.errors?.['required']">
                                                Mobile number is required.
                                            </small>

                                            <small class="text-red-500"
                                                *ngIf="createSetUpFormDelivery.get('contactNo')?.errors?.['pattern']">
                                                Please enter a valid 10-digit mobile number.
                                            </small>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Address Details -->
                            <div style="margin-top: 5px;">
                                <h4 class="text-xs font-semibold text-gray-900 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Address Details
                                </h4>

                                <div class="grid grid-cols-2 md:grid-cols-2 gap-1">
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Area / Locality</label>
                                        <input type="text" formControlName="address"
                                            placeholder="Enter area or locality"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Building / Plot</label>
                                        <input type="text" formControlName="plotNo" placeholder="Enter building or plot"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Street Name</label>
                                        <input type="text" formControlName="street" placeholder="Enter street name"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Landmark</label>
                                        <input type="text" formControlName="landMark"
                                            placeholder="Enter nearby landmark"
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-all" />
                                    </div>
                                </div>
                            </div>

                            <!-- Location Details -->
                            <div style="margin-top: 5px;">
                                <h4 class="text-xs font-semibold text-gray-900 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    Location Details
                                </h4>

                                <div class="grid grid-cols-2 md:grid-cols-2 gap-1">
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">State</label>
                                        <div class="relative">
                                            <select formControlName="stateCode"
                                                (change)="onStateSelect($any($event.target).value)"
                                                class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none appearance-none text-gray-700">
                                                <option value="" disabled selected>Select state</option>
                                                <option *ngFor="let state of stateList" [value]="state.refNo">{{
                                                    state.stateName }}</option>
                                            </select>
                                            <div class="absolute right-3 top-3 text-gray-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">District</label>
                                        <div class="relative">
                                            <select formControlName="districtCode"
                                                (change)="onDistrictSelect($any($event.target).value)"
                                                class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none appearance-none text-gray-700">
                                                <option value="" disabled selected>Select district</option>
                                                <option *ngFor="let district of districtList" [value]="district.id">{{
                                                    district.name }}</option>
                                            </select>
                                            <div class="absolute right-3 top-3 text-gray-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">City</label>
                                        <div class="relative">
                                            <select formControlName="cityCode"
                                                class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none appearance-none text-gray-700">
                                                <option value="" disabled selected>Select city</option>
                                                <option *ngFor="let city of cityList" [value]="city.id">{{ city.name }}
                                                </option>
                                            </select>
                                            <div class="absolute right-3 top-3 text-gray-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Pincode</label>
                                        <input type="text" formControlName="pincode" (keyup)="choosePincode()"
                                            placeholder="Enter pincode" readonly
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none cursor-pointer" />
                                    </div>
                                </div>
                            </div>

                            <!-- Map Section -->
                            <div style="margin-top: 5px;">
                                <h4 class="text-xs font-semibold text-gray-900 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-orange-600" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                                    </svg>
                                    Map Location
                                </h4>

                                <div class="space-y-3">
                                    <div class="relative">
                                        <input type="text" placeholder="Search location on map..." #search
                                            class="w-full px-2 py-2 text-xs bg-white border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none"
                                            [disabled]="!createSetUpFormDelivery.enabled" />
                                        <button type="button" (click)="fetchCurrentLoc()"
                                            class="absolute right-2 top-2 p-0.5 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20"
                                                fill="currentColor">
                                                <path fill-rule="evenodd"
                                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>

                                    <div class="rounded-lg overflow-hidden border border-gray-200">
                                        <div class="bg-gray-50 px-3 py-2 border-b border-gray-200">
                                            <div class="flex items-center gap-2">
                                                <div class="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                                                <span class="text-xs text-gray-600">Drag marker to adjust
                                                    location</span>
                                            </div>
                                        </div>
                                        <google-map height="250px" width="100%" [center]="center" [zoom]="zoom"
                                            [options]="mapOptions">
                                            <map-marker [position]="markerPosition" [options]="markerOptions"
                                                (mapDragend)="onMarkerDrag($event)">
                                            </map-marker>
                                        </google-map>
                                    </div>
                                </div>

                                <div class="grid grid-cols-2 md:grid-cols-2 gap-1">
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Latitude</label>
                                        <input type="text" formControlName="latitude" placeholder="Latitude" readonly
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none" />
                                    </div>
                                    <div class="space-y-1">
                                        <label class="text-xs text-gray-700 font-medium">Longitude</label>
                                        <input type="text" formControlName="longitude" placeholder="Longitude" readonly
                                            class="w-full px-2 py-2 text-xs bg-gray-50 border border-gray-300 rounded-lg focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none" />
                                    </div>
                                </div>
                            </div>

                            <!-- Submit Button -->
                            <div style="margin-top: 2px;" class="border-t border-gray-100">
                                <button type="submit"
                                    class="w-full px-8 py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 flex items-center justify-center gap-2">
                                    <span>Save Delivery Address</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                    </svg>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Actions -->
    <div mat-dialog-actions class="dialog-actions" *ngIf="!showDeliveryDetails">
        <!-- <button mat-button mat-dialog-close class="cancel-btn">Cancel</button> -->
        <button mat-button mat-dialog-close class="cancel-btn">
            Cancel
        </button>
        <button mat-button class="continue-btn" [disabled]="!selectedOption" (click)="onContinueClick(selectedOption)">
            <span>Continue</span>
        </button>
        <!-- <button mat-button class="continue-btn" *ngIf="showDeliveryDetails" (click)="onConfirmDelivery()">
            <span>Confirm Delivery</span>
        </button> -->
    </div>
</div>